export default () => {
  return 'https://template-ecommerce-backend.appbaystudio.com'
}